import verifyValidDateString from '~/utils/gcxDates/verifyValidDateString'

export type dateParamType = Date | number | string
type toDateFnType = (value: dateParamType) => Date

/**
 * @param `value` can be a Date object, a valid date string, or a unix timestamp:
 * example 1629235975000 => 2021-08-17 09:32:55
 */

const toDateFn: toDateFnType = (valueProp) => {
  const value = verifyValidDateString(valueProp)

  const date = new Date(value || valueProp)
  if (date.toString() === 'Invalid Date')
    throw new Error('Must pass a valid parameter to create a date object')

  return date
}

export default toDateFn
